import React from 'react';
import classnames from 'classnames';

import FieldIcon from './FieldIcon';

import { rawValue } from '../helpers/getRawValue';
import styles from './Equipments.module.scss';

const ZoneSectionBooleanField = ({ zones = [], fields = [] }) => (
  <div className={classnames(styles.wrapper, { [styles.multi]: zones.length > 1 })}>
    {zones.map(zone => (
      <ul
        key={zone.id_eae}
        className={styles.list}
        style={{ color: zone.color }}
      >
        {fields.map(field => (
          <li key={field} className={styles.item}>
            <FieldIcon field={field} value={rawValue(zone, field)} />
          </li>
        ))}
      </ul>
    ))}
  </div>
);

export default ZoneSectionBooleanField;
